import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBlocks"><Path fillRule="evenodd" clipRule="evenodd" d="M11 13H17.5V21H3V6.5H11V13ZM11 19.5H16V14.5H11V19.5ZM4.5 13H9.5V8H4.5V13Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 11H13V3H21V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlocks;
